import React from "react";
import "./ERP.css";
import SEO from "../../SEO";
const softwareServices = [
  {
    title: "Point Of Sale (POS) System",
    description:
      "Our advanced Point of Sale (POS) system is designed for retail stores, supermarkets, restaurants, and wholesale businesses. It provides fast billing, barcode scanning, inventory tracking, and real-time sales reporting. The system supports both desktop and mobile devices to ensure seamless checkout operations.",
    features: [
      "Fast Billing System",
      "Barcode Scanning",
      "Thermal Receipt Printing",
      "Inventory Management",
      "Discount & Tax Management",
      "Sales Reporting",
      "Mobile POS Support",
    ],
    img: process.env.PUBLIC_URL + "/img/desktop-app.gif",
    icon: "bi-receipt",
  },
  {
    title: "POS ERP Management System",
    description:
      "Our complete POS ERP solution integrates sales, inventory, accounts, HRMS, and reporting into one powerful platform. Available as Desktop Application, Web Application, and Mobile App, it enables real-time data synchronization, centralized control, and business automation across multiple branches.",
    features: [
      "Desktop Application",
      "Web Application",
      "Mobile App",
      "Accounts & Finance Module",
      "HRMS & Payroll",
      "Employee Attendance",
      "Barcode & Stock Control",
      "Multi-Branch Management",
      "Role-Based Access",
      "Cloud Backup & Reports",
    ],
    img: process.env.PUBLIC_URL + "/img/ERP-Management-System-Gif.gif",
    icon: "bi-diagram-3",
  },
];

function ERP() {
  return (
    <>
      <SEO
        title="ERP Solutions – MZR Software"
        description="Streamline your business processes with MZR Software’s enterprise ERP solutions."
        image="https://mzrsoftware.com/assets/images/og-erp.jpg"
        url="https://mzrsoftware.com/OurServices/ERP/erp"
      />

      <div className="custom-software-page">
        <section className="services-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">
                Our <span className="highlight">POS & ERP Solutions</span>
              </h2>
              <p className="section-subtitle">
                Complete retail and enterprise management system with POS,
                Accounts, HRMS, Inventory, and Mobile Integration.
              </p>
            </div>

            <div className="services-grid">
              {softwareServices.map((service, index) => (
                <div
                  key={index}
                  className={`service-card zig-zag ${
                    index % 2 === 0 ? "left" : "right"
                  }`}
                >
                  {/* Content */}
                  <div className="card-content">
                    <span className={`bi ${service.icon} service-icon`}></span>
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <div className="service-features">
                      {service.features.map((feature, i) => (
                        <span key={i} className="feature-tag">
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Image */}
                  <div className="card-image">
                    <img src={service.img} alt={service.title} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default ERP;
